// JA UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'アパートメントとホテル',
  'site.currency': '通貨',
  'site.language': '言語',
  'site.currencySelector': '通貨選択',
  'site.languageSelector': '言語選択',
  'site.menu': 'メニュー',
  'site.signIn': 'サインイン',
  'site.signOut': 'サインアウト',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'メニューを開く',
  'site.footer.copyright': '無断転載を禁じます。',
  'site.footer.manageBooking': '予約を管理',
  'site.footer.terms': '利用規約',
  'site.footer.privacy': 'プライバシーポリシー',
  'site.trust.bestPrice': '最安値保証',
  'site.trust.bestPriceDesc': '最適な料金でご案内します。',
  'site.trust.flexibleBooking': '柔軟な予約',
  'site.trust.flexibleBookingDesc': '変更・キャンセルも簡単です。',
  'site.trust.securePayments': '安全な決済',
  'site.trust.securePaymentsDesc': '安心・安全なチェックアウト。',
  'site.trust.localSupport': '現地サポート',
  'site.trust.localSupportDesc': 'いつでもお手伝いいたします。',
  'home.heroTitle': '理想の滞在を見つけよう',
  'home.inAustralia': 'オーストラリアで',
  'home.heroSubtitle': 'あらゆる滞在にぴったりのアパートメントとホテル',
  'home.errorLoading': '物件を読み込めませんでした。',
  'home.noPropertiesTitle': '現在ご利用できる物件がありません。',
  'home.noPropertiesDescription': '目的地を検索して、利用可能な滞在を探索してみてください。',
  'home.exploreStays': '滞在を探す',
  'home.property': '件',
  'home.property_one': '件',
  'home.property_other': '件',
  'home.properties': '件',
  'home.foundInAustralia': 'オーストラリアで見つかりました',
  'search.errorLoading': '空室状況を読み込めませんでした。もう一度お試しください。',
  'search.noResults': '検索条件に一致する物件がありません。',
  'search.mapFollow': '地図を移動するたびに検索',
  'search.chooseLocationTitle': '場所を選択',
  'search.chooseLocationDescription': '目的地を選択してから、利用可能な滞在を検索してください。',
  'search.chooseDatesTitle': '日程を選択',
  'search.pastCheckIn': 'チェックイン日は過去を指定できません。',
  'search.checkOutAfterCheckIn': 'チェックアウト日はチェックイン日の後である必要があります。',
  'search.property': '件',
  'search.property_one': '件',
  'search.property_other': '件',
  'search.properties': '件',
  'search.found': '見つかりました',
  'widget.where': '場所',
  'widget.location': 'ロケーション',
  'widget.checkInOut': 'チェックイン / チェックアウト',
  'widget.guests': 'ゲスト',
  'widget.rooms': '部屋',
  'widget.promoCode': 'プロモコード',
  'widget.promoPlaceholderCompact': 'コードを追加（任意）',
  'widget.promoPlaceholder': '任意',
  'widget.search': '検索',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': '大人',
  'widget.adults': '大人',
  'widget.child': '子供',
  'widget.children': '子供',
  'widget.decreaseAdults': '大人を減らす',
  'widget.increaseAdults': '大人を増やす',
  'widget.decreaseChildren': '子供を減らす',
  'widget.increaseChildren': '子供を増やす',
  'widget.room': '部屋',
  'widget.adultOption': '{count} 名様',
  'widget.adultOption_one': '{count} 名様',
  'widget.adultOption_other': '{count} 名様',
  'widget.childOption': '{count} 名',
  'widget.childOption_one': '{count} 名',
  'widget.childOption_other': '{count} 名',
  'widget.roomOption': '{count} 部屋',
  'widget.roomOption_one': '{count} 部屋',
  'widget.roomOption_other': '{count} 部屋',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'ロケーションを読み込めませんでした。もう一度お試しください。',
  'widget.searchAria': '空室を検索',
  'widget.dateErrorRequired': 'チェックイン日とチェックアウト日の両方を選択してください。',
  'widget.dateErrorPast': 'チェックイン日は過去を指定できません。',
  'widget.dateErrorRange': 'チェックアウト日はチェックイン日の後である必要があります。',
  'widget.dateRange.placeholder': 'チェックイン日とチェックアウト日を選択',
  'widget.dateRange.selectCheckout': 'チェックアウトを選択',
  'widget.dateRange.aria.checkIn': 'チェックイン',
  'widget.dateRange.aria.checkOut': 'チェックアウト',
  'widget.dateRange.aria.picker': 'チェックイン / チェックアウト日選択',
  'widget.dateRange.previousMonth': '前月',
  'widget.dateRange.nextMonth': '翌月',
  'widget.dateRange.selectCheckIn': 'チェックイン日を選択',
  'widget.dateRange.selectCheckOut': 'チェックアウト日を選択',
  'widget.dateRange.resetToday': '今日に戻す',
  'widget.dateRange.done': '完了',
  'property.heroAlt': '物件メイン画像',
  'property.fallbackName': '{site}の選択物件',
  'property.chooseRoom': 'お部屋を選ぶ',
  'property.filterBy': '絞り込み：',
  'property.filterAll': 'すべての部屋',
  'property.filterStudios': 'スタジオ',
  'property.filter1Bed': '1ベッドルーム',
  'property.filter2Bed': '2ベッドルーム',
  'property.filterApartments': 'アパートメント',
  'property.sortBy': '並び替え：',
  'property.sortRecommended': 'おすすめ',
  'property.sortPriceLow': '価格：安い順',
  'property.sortPriceHigh': '価格：高い順',
  'property.errorLoading': '空室状況を読み込めませんでした。もう一度お試しください。',
  'property.noRooms': '利用可能な部屋がありません',
  'property.noRoomsDescription': '別の日程または人数でお試しください。',
  'property.totalForNights': '{nights}泊の合計',
  'property.perNight': '/ 1泊',
  'property.night': '泊',
  'property.night_one': '泊',
  'property.night_other': '泊',
  'property.nights': '泊',
  'property.freeCancellation': '無料キャンセル',
  'property.selectRoom': '部屋を選択',
  'property.selected': '選択済み',
  'property.continue': '続ける',
  'property.previousPhoto': '前の写真',
  'property.nextPhoto': '次の写真',
  'property.addToWishlist': 'お気に入りに追加',
  'property.popularChoice': '人気の選択',
  'property.showMore': 'もっと見る',
  'property.showLess': '閉じる',
  'property.maxOccupancy': '最大定員：',
  'property.size': '広さ：',
  'property.bedType': 'ベッドタイプ：',
  'property.roomAmenities': '客室設備',
  'property.showMoreAmenities': '他 {count} 件',
  'property.guests': 'ゲスト',
  'property.adults': '大人',
  'property.children': '子供',
  'property.onlyRoomsLeft': '残り{count}室のみ',
  'property.onlyRoomsLeft_one': '残り{count}室のみ',
  'property.onlyRoomsLeft_other': '残り{count}室のみ',
  'property.lastBookedMinutes': '{count}分前に最終予約',
  'property.lastBookedMinutes_one': '{count}分前に最終予約',
  'property.lastBookedMinutes_other': '{count}分前に最終予約',
  'property.lastBookedHours': '{count}時間前に最終予約',
  'property.lastBookedHours_one': '{count}時間前に最終予約',
  'property.lastBookedHours_other': '{count}時間前に最終予約',
  'property.lastBookedDays': '{count}日前に最終予約',
  'property.lastBookedDays_one': '{count}日前に最終予約',
  'property.lastBookedDays_other': '{count}日前に最終予約',
  'property.checkInTime': 'チェックイン {time}',
  'property.checkOutTime': 'チェックアウト {time}',
  'property.compare': '比較',
  'property.taxesIncluded': '税・サービス料込みの1泊あたり',
  'property.chooseRate': 'レートを選ぶ',
  'property.yourSelection': 'ご選択内容',
  'property.aboutRoom': 'この部屋について',
  'property.roomDetails': '部屋の詳細',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': '部屋一覧に戻る',
  'property.standardRate': 'スタンダードレート',
  'property.noPromotion': 'このレートに利用できるプロモーションはありません。',
  'property.youSave': '（{percent}%オフ） - {amount}',
  'property.inclusions': '含まれるもの：',
  'property.viewAllPhotos': 'すべての写真を見る',
  'property.seeOnMap': '地図で見る',
  'room.perNight': '1泊',
  'room.sleeps': '宿泊可能人数',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': '利用可能',
  'room.select': '選択',
  'room.selected': '選択済み',
  'card.viewAvailability': '空室を確認',
  'card.from': 'から',
  'card.night': '泊',
  'card.checkAvailability': '空室を確認',
  'card.saveToFavourites': 'お気に入りに保存',
  'card.ratingExcellent': '最高',
  'card.ratingVeryGood': 'とても良い',
  'card.ratingGood': '良い',
  'card.ratingGuest': 'ゲスト評価',
  'guest.stepChooseRoom': '部屋を選ぶ',
  'guest.stepGuestDetails': '宿泊者情報',
  'guest.stepPayment': 'お支払い',
  'guest.stepConfirmation': '予約確定',
  'guest.title': '宿泊者情報を入力',
  'guest.subtitle': '必要事項を入力してください。',
  'guest.firstName': '名',
  'guest.lastName': '姓',
  'guest.email': 'メールアドレス',
  'guest.emailHint': '予約確認メールはこちらのメールアドレスに送信されます。',
  'guest.country': '国',
  'guest.selectCountry': '国を選択',
  'guest.searchCountry': '国を検索…',
  'guest.loadingCountries': '国を読み込み中…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': '郵便番号',
  'guest.phone': '電話番号',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': '電話番号を入力',
  'guest.address': '住所',
  'guest.city': '市区町村',
  'guest.specialRequests': '特別リクエスト（任意）',
  'guest.specialRequestsPlaceholder': '特別なご要望はありますか？',
  'guest.termsPrefix': 'この予約を完了することで、',
  'guest.terms': '利用規約',
  'guest.termsAnd': 'および',
  'guest.privacy': 'プライバシーポリシー',
  'guest.termsSuffix': 'に同意し、予約条件を受け入れるものとします。',
  'guest.marketingOptOut': 'マーケティングメッセージを受け取りたくない。',
  'guest.cardVerify':
    '一時的に1 {currency}のカード確認が行われます。今すぐ請求されることはありません。',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'お支払いは施設でいただきます。',
  'guest.noRoomsSelected': '部屋が選択されていません。',
  'guest.noPropertySelected': '物件が選択されていません。',
  'guest.paymentStillLoading':
    'お支払いオプションを読み込み中です。しばらくしてからもう一度お試しください。',
  'guest.submitProcessing': '処理中…',
  'guest.submitVerifyCard': 'カードを確認して予約を確定',
  'guest.submitConfirm': '予約を確定',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'お支払い',
  'payment.method': 'お支払い方法',
  'payment.cardDetailsHint':
    '以下にカード情報を安全に入力してください。カード情報はトークン化され、当社のサーバーには保存されません。',
  'payment.loadingForm': '決済フォームを読み込み中…',
  'payment.formUnavailable': '決済フォームが利用できません。',
  'payment.acceptTerms': '利用規約およびキャンセルポリシーに同意します。',
  'payment.payNow': '今すぐ支払う',
  'payment.processing': '処理中…',
  'payment.noRoomsSelected': '部屋が選択されていません。',
  'payment.redirecting': '安全な決済ページにリダイレクトしています…',
  'payment.notConfigured': 'この物件にはQuickstreamが設定されていません。',
  'payment.noScript': 'Quickstream決済サービスを読み込めませんでした。ページを更新してください。',
  'payment.formNotLoaded': '決済フォームが読み込まれていません。ページを更新してください。',
  'payment.cardDetails': 'お支払いに失敗しました。カード情報を確認してください。',
  'payment.tokenizationFailed': 'カードのトークン化に失敗しました。もう一度お試しください。',
  'payment.failed': 'お支払いに失敗しました。',
  'payment.statusResult': '決済ステータス：{status}。もう一度お試しください。',
  'confirmation.loading': '予約を読み込み中…',
  'confirmation.notFound': '予約が見つかりません。予約番号を確認してもう一度お試しください。',
  'confirmation.errorGeneric': '予約を確定できませんでした。サポートにお問い合わせください。',
  'confirmation.errorLoadDetails': '予約詳細を読み込めませんでした。',
  'confirmation.couldNotComplete': 'お支払いを完了できませんでした',
  'confirmation.startNew': '新しい予約を始める',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound':
    '決済セッションが見つかりません。サポートにお問い合わせください。',
  'confirmation.paymentStateInvalid':
    '決済が完了可能な状態ではありません。最初からやり直してください。',
  'confirmation.paymentFailedDeclined':
    'お支払いを完了できませんでした。カード情報を確認してもう一度お試しになるか、別の決済方法をご利用ください。',
  'confirmation.paymentTimeout': '決済に時間がかかりすぎました。もう一度お試しください。',
  'confirmation.paymentGatewayUnavailable':
    '決済システムが一時的に利用できません。しばらくしてからもう一度お試しください。',
  'confirmation.paymentUnknown': '決済を確認できません：{message}。',
  'confirmation.paymentGenericError':
    '決済を確認できませんでした。もう一度お試しになるか、サポートにお問い合わせください。',
  'summary.title': '予約内容の確認',
  'summary.yourBooking': '予約内容の確認',
  'summary.noRoomsSelected': 'まだ部屋が選択されていません。',
  'summary.checkIn': 'チェックイン',
  'summary.checkOut': 'チェックアウト',
  'summary.lengthOfStay': '滞在期間',
  'summary.guests': 'ゲスト',
  'summary.nights': '{nights}泊',
  'summary.nights_one': '{nights}泊',
  'summary.nights_other': '{nights}泊',
  'summary.totalForNights': '{nights}泊の合計',
  'summary.includingTaxes': '税・サービス料込み',
  'summary.discount': '{amount} お得',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': '予約確定！',
  'detail.received': '予約を受け付けました',
  'detail.referenceIntro': '予約番号は',
  'detail.reservationId': '予約番号：',
  'detail.processing': '予約を処理中です。決済が確認され次第、確認メールをお送りします。',
  'detail.guest': 'ゲスト',
  'detail.rooms': '部屋',
  'detail.night': '泊',
  'detail.nights': '泊',
  'detail.adult': '大人',
  'detail.adults': '大人',
  'detail.child': '子供',
  'detail.infant': '乳幼児',
  'detail.priceBreakdown': '内訳',
  'detail.subtotal': '小計',
  'detail.taxes': '税',
  'detail.fees': 'サービス料',
  'detail.discounts': '割引',
  'detail.surcharge': 'カード手数料',
  'detail.grandTotal': '合計',
  'priceBreakdown.roomSubtotal': '部屋小計',
  'priceBreakdown.total': '合計',
  'detail.deposit': 'デポジット',
  'detail.depositDueBy': 'までにお支払い',
  'detail.arrival': '到着',
  'detail.specialRequests': '特別リクエスト',
  'detail.backToHome': 'ホームに戻る',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': '再試行',
  'shared.close': '閉じる',
  'shared.back': '戻る',
  'shared.previous': '前へ',
  'shared.next': '次へ',
  'validation.firstNameRequired': '名を入力してください',
  'validation.lastNameRequired': '姓を入力してください',
  'validation.emailRequired': '有効なメールアドレスを入力してください',
  'validation.phoneRequired': '電話番号を入力してください',
  'validation.addressRequired': '住所を入力してください',
  'validation.cityRequired': '市区町村を入力してください',
  'validation.countryRequired': '国を選択してください',
  'validation.postalCodeRequired': '郵便番号を入力してください',
  'error.pmsUnavailable':
    '選択された日程ではこの部屋の空室がなくなりました。別の日程または別の部屋をお選びください。',
  'error.pmsSyncError':
    '物件システムに接続できませんでした。しばらくしてからもう一度お試しください。',
  'error.paymentNotConfigured':
    'この物件ではお支払いが設定されていません。別の物件をお選びいただくか、サポートにお問い合わせください。',
  'error.paymentStartFailed': '決済の開始中に問題が発生しました。もう一度お試しください。',
  'error.bookingFailed': '予約に失敗しました。もう一度お試しください。',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': '宿泊を予約',
  'site.title.suffix': 'アパートメントとホテル',
  'site.title.home': 'ホーム',
  'site.title.search': '検索',
  'site.title.property': '物件',
  'site.title.room': '部屋',
  'site.title.guestDetails': '宿泊者情報',
  'site.title.payment': 'お支払い',
  'site.title.confirmation': '予約確定',
  'site.title.bookingLookup': '予約を探す',
  'site.title.bookingDetails': '予約詳細',
  'site.title.cancellation': '予約キャンセル',
  'site.title.reservationDetail': '予約詳細',
  'site.title.signIn': 'サインイン',
  'site.title.signUp': 'サインアップ',
  'site.title.notFound': 'ページが見つかりません',
  'notFound.title': 'ページが見つかりません',
  'notFound.message': 'お探しのページは存在しません。',
  'notFound.backHome': 'ホームに戻る',
  'home.heroAlt': 'オーストラリアの街並み',
  'home.featuredProperties': 'おすすめ物件',
  'home.popularDestinations': '人気の目的地',
  'common.reviews': '{count} 件のレビュー',
  'common.reviews_one': '{count} 件のレビュー',
  'common.reviews_other': '{count} 件のレビュー',
  'common.loading': '読み込み中',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': '/',
  'common.select': '選択…',
  'common.search': '検索…',
  'common.selectLocation': 'ロケーションを選択',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': '利用可能なオプションがありません',
  'common.code': 'コード',
  'common.searchCode': 'コードを検索…',
  'filter.title': 'フィルター',
  'filter.price': '価格',
  'filter.priceMinimum': '最低',
  'filter.priceMaximum': '最高',
  'filter.priceMinPlaceholder': '¥0',
  'filter.priceMaxPlaceholder': '¥500+',
  'filter.propertyType': '物件タイプ',
  'filter.propertyType.hotel': 'ホテル',
  'filter.propertyType.apartment': 'アパートメント',
  'filter.propertyType.resort': 'リゾート',
  'filter.amenities': '施設',
  'filter.amenity.pool': 'プール',
  'filter.amenity.parking': '駐車場',
  'filter.amenity.breakfast': '朝食付き',
  'filter.rating': '評価',
  'filter.rating.any': '指定なし',
  'filter.rating.5': '5つ星',
  'filter.rating.4': '4つ星以上',
  'filter.rating.3': '3つ星以上',
  'filter.more': 'その他',
  'filter.more.freeCancellation': '無料キャンセル',
  'filter.more.payAtProperty': '施設で支払い',
  'filter.clear': 'クリア',
  'filter.apply': 'フィルターを適用',
  'card.reviews_one': 'レビュー',
  'card.reviews_other': 'レビュー',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': '0〜12歳',
  'auth.orContinueWith': 'またはこちらで続ける',
  'auth.signIn.title': 'アカウントにサインイン',
  'auth.signIn.subtitle':
    'お帰りなさい。サインインすると予約の管理、滞在の確認、限定オファーへアクセスできます。',
  'auth.email': 'メールアドレス',
  'auth.emailPlaceholder': 'メールアドレスを入力',
  'auth.emailRequired': 'メールアドレスを入力してください。',
  'auth.emailInvalid': '有効なメールアドレスを入力してください。',
  'auth.password': 'パスワード',
  'auth.passwordPlaceholder': 'パスワードを入力',
  'auth.createPasswordPlaceholder': 'パスワードを作成',
  'auth.passwordRequired': 'パスワードを入力してください。',
  'auth.passwordMinLength': 'パスワードは{min}文字以上である必要があります。',
  'auth.passwordPattern': 'パスワードは文字と数字を含める必要があります。',
  'auth.passwordHint': '文字、数字、記号を含む{min}文字以上を使用してください。',
  'auth.showPassword': 'パスワードを表示',
  'auth.hidePassword': 'パスワードを隠す',
  'auth.keepSignedIn': 'サインインを保持する',
  'auth.forgotPassword': 'パスワードをお忘れですか？',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'サインイン',
  'auth.signingIn': 'サインイン中…',
  'auth.signInError': 'サインインに失敗しました。もう一度お試しください。',
  'auth.googleError': 'Googleサインインに失敗しました。',
  'auth.noAccount': 'アカウントをお持ちでないですか？',
  'auth.createAccount': 'アカウントを作成',
  'auth.signUp.title': 'アカウントを作成',
  'auth.signUp.subtitle':
    '{site}に参加して、予約を管理し、お気に入りの物件を保存し、限定オファーを受け取りましょう。',
  'auth.firstName': '名',
  'auth.firstNamePlaceholder': '名を入力',
  'auth.firstNameRequired': '名を入力してください。',
  'auth.lastName': '姓',
  'auth.lastNamePlaceholder': '姓を入力',
  'auth.lastNameRequired': '姓を入力してください。',
  'auth.mobile': '携帯電話番号',
  'auth.mobilePlaceholder': '携帯電話番号を入力',
  'auth.dialingCode': '国番号',
  'auth.mobileRequired': '携帯電話番号を入力してください。',
  'auth.mobileInvalid': '有効な携帯電話番号を入力してください。',
  'auth.confirmPassword': 'パスワード（確認）',
  'auth.confirmPasswordPlaceholder': 'パスワードを確認',
  'auth.termsAgree': '以下に同意します： ',
  'auth.termsRequired': '利用規約およびプライバシーポリシーに同意する必要があります。',
  'auth.marketingConsent': '{site}からの限定オファーや旅のインスピレーションを受け取りたい。',
  'auth.signUpError': 'アカウントを作成できませんでした。もう一度お試しください。',
  'auth.signUp': 'サインアップ',
  'auth.creatingAccount': 'アカウント作成中…',
  'auth.createAccountButton': 'アカウントを作成',
  'auth.alreadyHaveAccount': 'すでにアカウントをお持ちですか？',
  'auth.passwordMismatch': 'パスワードが一致しません。',
  'pricing.title': '料金の確認',
  'pricing.noRoomsSelected': '部屋が選択されていません。部屋一覧に戻って選択してください。',
  'pricing.backToAvailability': '空室一覧に戻る',
  'pricing.continue': '宿泊者情報へ進む',
  'property.youSavePercent': '（{percent}%オフ）',
  'property.includingTaxesFees': '（税・サービス料込み）',
  'map.zoomIn': '拡大',
  'map.zoomOut': '縮小',
  'map.viewFullMap': '地図を全体表示',
  'booking.progress': '予約の進行状況',
  'reservationDetail.resetAria': '予約状態をリセット',
  'bookingLookup.title': '予約を探す',
  'bookingLookup.description':
    '予約番号とメールアドレスを入力して、予約の確認・変更・キャンセルができます。',
  'bookingLookup.bookingReference': '予約番号',
  'bookingLookup.placeholder': '例：SYD-260815-0001',
  'bookingLookup.lookingUp': '検索中…',
  'bookingLookup.findBooking': '予約を探す',
  'bookingLookup.notFound':
    '予約が見つかりません。BK-2026-001、alex.morgan@example.com、Morganをお試しください。',
  'cancellation.title': '予約をキャンセル',
  'cancellation.property': '物件',
  'cancellation.details': 'キャンセル詳細',
  'cancellation.penalty': 'キャンセル料',
  'cancellation.refund': '返金額',
  'cancellation.totalPaid': 'お支払い合計：',
  'cancellation.reasonLabel': 'キャンセル理由（任意）',
  'cancellation.understand': 'この操作は元に戻せないことを理解しています。',
  'cancellation.cancelledDemo':
    'このデモUIでは予約がキャンセルされました。返金額：{{refundAmount}}。',
  'cancellation.confirm': 'キャンセルを確定',
  'cancellation.notFound': '予約が見つかりません。',
  'bookingDetails.title': '予約詳細',
  'bookingDetails.notFound': '予約が見つかりません。',
  'bookingDetails.checkIn': 'チェックイン：',
  'bookingDetails.checkOut': 'チェックアウト：',
  'bookingDetails.rooms': '部屋',
  'bookingDetails.guest': 'ゲスト',
  'bookingDetails.freeCancellationUntil': '{date}まで無料キャンセル',
  'bookingDetails.total': '合計：',
  'reservationDetail.loading': '予約を読み込み中…',
  'reservationDetail.noReference': '予約番号が入力されていません。',
  'reservationDetail.loadError': '予約詳細を読み込めませんでした。',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'ロケーションを読み込み中…',
  'common.couldNotLoadLocations': 'ロケーションを読み込めませんでした',
  'common.searchLocationPlaceholder': '国、都市、物件を検索',
  'common.collapse': '折りたたむ',
  'common.expand': '展開する',
  'map.loadingGoogle': 'Googleマップを読み込み中…',
  'map.errorGoogle': 'Googleマップの読み込みに失敗しました',
  'map.errorMap': '地図の読み込みに失敗しました。',
  'map.greatLocation': '最高のロケーション',
  'home.trust.secureBooking': '安全な予約',
  'home.trust.secureBookingDesc': 'あなたの情報は安全に保護されます。',
  'home.trust.bestPrice': '最安値保証',
  'home.trust.bestPriceDesc': 'より安い価格が見つかった場合、お値段を合わせます。',
  'home.trust.localSupport': '24時間365日サポート',
  'home.trust.localSupportDesc': 'いつでもお手伝いいたします。',
  'home.trust.flexibleBooking': '柔軟なオプション',
  'home.trust.flexibleBookingDesc': '対象レートなら無料キャンセル。',
  'promotion.memberPromo': '会員限定プロモ',
  'promotion.save': '割引',
  'property.memberRate': '会員レート',
  'property.hideAmenities': '施設を隠す',
  'property.showAllAmenities': 'すべての施設を表示',
  'property.chooseRatePromo': 'お好みのレートを選択 - 会員レートは特別割引があります！',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}%オフ',
  'gallery.imageAlt': '{title}の写真 {current}/{total}',
  'gallery.thumbnailAlt': '写真 {current}/{total} を表示',
  'gallery.previewAlt': '{title}のプレビュー',
  'detail.night_one': '泊',
  'detail.night_other': '泊',
  'detail.adult_one': '大人',
  'detail.adult_other': '大人',
  'detail.child_one': '子供',
  'detail.child_other': '子供',
  'detail.infant_one': '乳幼児',
  'detail.infant_other': '乳幼児',
} as const;
